import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { apiBaseUrl } from "network";

export const quizApi = createApi({
    reducerPath: "quizApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        updateQuiz: builder.mutation({
            query: (body) => ({ url: "vendor/quiz", method: "PUT", body: body }),
        }),
        addQuiz: builder.mutation({
            query: (body) => ({ url: "vendor/quiz", method: "POST", body: body }),
        }),
        getAllQuizList: builder.query({
            query: ({ page, limit, search }) => ({
                url: `vendor/quiz?page=${page}&limit=${limit}&search=${search}`
            }),
            transformResponse: (response) => response
        }),
    })
})

export const { useAddQuizMutation, useGetAllQuizListQuery, useUpdateQuizMutation } = quizApi;
